requirejs([
    'jquery'
],
function($) {
    $(document).on('amscroll_refresh', () => $('body').toggleClass('filter-menu-open', $('.sidebar.block.filter').hasClass('open')));
});
